import styled from "styled-components";
import Colors from "../../../shared/colors";

export default styled.div`
  background: ${Colors.alabaster};
  padding: 140px 0px 100px 0px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;

  .layout {
    max-width: 1100px;
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  .custom-style {
    @media screen and (max-width: 1025px) {
      display: block !important;
    }
  }

  .wrapper-flex {
    display: flex;
    justify-content: space-between;
    align-self: center;

    div {
      align-self: center;
      margin-bottom: 5px;
      min-height: 20px;
    }

    .left-button {
      margin-right: 30px;
      color: ${Colors.orient};
      text-decoration-line: underline;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      cursor: pointer;
    }

    .left-button:hover {
      color: ${Colors.blumine};
    }
  }

  .renew-button {
    margin-left: 30px;
  }

  .print-tif {
    cursor: pointer;

    span {
      text-decoration-line: underline;
      color: ${Colors.aquaDeep};
      margin-right: 10px;
    }
  }

  .print-tif:hover {
    span {
      color: ${Colors.blumine};
    }

    svg path {
      fill: ${Colors.blumine};
    }
  }

  .extra-text-button {
    color: ${Colors.orient};
    text-align: center;
  }

  .custom-checkbox {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: justify;
  }

  .accordion {
    border: 0;
    margin: 20px 0;
  }
  .accordion__panel {
    background: ${Colors.white};
    padding: 0px 20px 20px 20px;
    animation: none;
  }

  .accordion__heading:focus,
  .accordion__button:focus {
    outline: none;
  }

  .accordion__button {
    position: relative;
    background-color: ${Colors.white};
  }

  .accordion__button[aria-expanded="true"] {
    margin-bottom: 23px;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 10%);
  }

  .accordion__item {
    margin-bottom: 10px;
  }

  .accordion__item + .accordion__item {
    border-top: 0;
  }

  .accordion__button:before {
    content: "▼";
    border: 0;
    transform: initial;
    color: ${Colors.aquaDeep};
    right: 20px;
    position: absolute;
  }

  .accordion__button[aria-expanded="true"]::before,
  .accordion__button[aria-selected="true"]::before {
    content: "▲";
    z-index: 1;
    width: 20px;
    height: 25px;
    text-align: right;
    font-size: initial;
  }

  .wrapper-pannel {
    position: relative;
    margin-top: -19px;
  }

  .accordion__button .paf-issues-date {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: ${Colors.doveGray};
  }

  .paf-issued-date {
    float: right;
    margin-right: 50px;

    span {
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 19px;
      letter-spacing: 0em;
      color: ${Colors.mineShaft};
    }
  }

  .second-text {
    > div {
      > p {
        font-size: 16px !important;
        line-height: 19px !important;
      }
    }
  }

  .renewal-text {
    font-size: 10px;
    line-height: 12px;
    text-align: center;
    color: #00594c;
    margin-top: 2px;
  }
`;
